window.cpap.onDocumentReady(() => {
  // 🚨 This is only for user-blocking logic. Nothing that is user-visible or background should be included here!
  // @see https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API#task_priorities
  window.scheduler.postTask(
    () => {
      const searchModalNode = document.querySelector('.cpap__header-search-modal__body');
      const searchModalInputNode = searchModalNode.querySelector('input.search__input');
      let focusTimeoutId;

      document.querySelector('.cpap__header-search__button-container')?.addEventListener(
        'click',
        () => {
          window.cpap.dynamicallyLoadScript(window.cpap.cdnSources.cpapHeaderSearchModalJs);

          document.body.classList.add('overflow-hidden');
          searchModalNode.classList.add('active');

          clearTimeout(focusTimeoutId);

          focusTimeoutId = setTimeout(
            () => searchModalInputNode.focus(),
            window.appConfig.HOVER_DELAY_DURATION
          );
        },
        { passive: true }
      );
    },
    { priority: 'user-blocking' }
  );
});
